import React, { useEffect, useState, useRef, lazy } from 'react';
import { TestimonialCard } from './TestimonialCard';
import { CTAButton } from './CTAButton';
import { StickyCTA } from './StickyCTA';
import { EyeIcon, CheckCircle, AlertCircle } from 'lucide-react';
export const Advertorial = () => {
  const [isScrolledPastFirstTwoSections, setIsScrolledPastFirstTwoSections] = useState(false);
  const [isAtTopSection, setIsAtTopSection] = useState(true);
  const [userCity, setUserCity] = useState('New York');
  const firstTwoSectionsRef = useRef(null);
  // Fetch user location data
  useEffect(() => {
    const fetchUserLocation = async () => {
      try {
        const response = await fetch('https://ipinfo.io/json');
        if (response.ok) {
          const data = await response.json();
          if (data.city && data.city.trim() !== '') {
            setUserCity(data.city);
            console.log(`User location detected: ${data.city}`);
          }
        }
      } catch (error) {
        console.error('Error fetching location data:', error);
      }
    };
    fetchUserLocation();
  }, []);
  useEffect(() => {
    setIsScrolledPastFirstTwoSections(false);
    setIsAtTopSection(true);
    const scrollOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -90% 0px'
    };
    const topSectionOptions = {
      threshold: 0.3,
      rootMargin: '-100px 0px 0px 0px'
    };
    const scrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          setIsScrolledPastFirstTwoSections(true);
        } else {
          setIsScrolledPastFirstTwoSections(false);
        }
      });
    }, scrollOptions);
    const topSectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsAtTopSection(true);
        } else {
          setIsAtTopSection(false);
        }
      });
    }, topSectionOptions);
    setTimeout(() => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.observe(firstTwoSectionsRef.current);
        topSectionObserver.observe(firstTwoSectionsRef.current);
      }
    }, 100);
    return () => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.unobserve(firstTwoSectionsRef.current);
        topSectionObserver.unobserve(firstTwoSectionsRef.current);
      }
    };
  }, []);
  useEffect(() => {
    console.log('Scrolled past first two sections:', isScrolledPastFirstTwoSections, 'At top section:', isAtTopSection);
  }, [isScrolledPastFirstTwoSections, isAtTopSection]);
  return <div className="w-full bg-white" data-id="element-7">
      {/* Top Header Bar */}
      <div className="w-full bg-gray-900 text-white" data-id="element-8">
        <div className="container mx-auto px-4 py-2 flex justify-between items-center" data-id="element-9">
          <div className="flex items-center" data-id="element-10">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2" data-id="element-11">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="white" data-id="element-12" />
            </svg>
            <span className="font-semibold tracking-wider" data-id="element-13">WOMEN'S HEALTH</span>
          </div>
          <div className="flex items-center" data-id="element-14">
            <div className="w-5 h-5 mr-2 rounded-full overflow-hidden" data-id="element-15">
              <svg viewBox="0 0 512 512" className="w-full h-full" data-id="element-16">
                <path fill="#f0f0f0" d="M0 85.331h512v341.337H0z" data-id="element-17" />
                <path fill="#d80027" d="M0 85.331h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0z" data-id="element-18" />
                <path fill="#2e52b2" d="M0 85.331h256v183.797H0z" data-id="element-19" />
                <path fill="#f0f0f0" d="M99.822 160.624L95.699 173.308H82.363L93.113 181.143L89.021 193.826L99.822 186.034L110.624 193.826L106.532 181.143L117.306 173.308H103.97z" data-id="element-20" />
                <path fill="#f0f0f0" d="M103.622 219.081l-3.284 10.134h-10.638l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333h-10.638zM167.737 160.624l-4.123 12.684h-13.336l10.75 7.835-4.092 12.683 10.801-7.792 10.802 7.792-4.092-12.683 10.774-7.835h-13.336zM167.737 219.081l-3.284 10.134h-10.638l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333h-10.638zM31.908 160.624l-4.123 12.684H14.449l10.75 7.835-4.092 12.683 10.801-7.792 10.802 7.792-4.092-12.683 10.774-7.835H36.031zM31.908 219.081l-3.284 10.134H17.986l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333H35.192z" data-id="element-21" />
              </svg>
            </div>
            <span className="text-sm" data-id="element-22">Trending in the US</span>
          </div>
        </div>
      </div>

      {/* Header */}
      <header className="w-full border-b border-gray-200" data-id="element-23">
        <div className="container mx-auto px-4 py-3" data-id="element-24">
          <p className="text-xs font-semibold text-gray-500 tracking-wider" data-id="element-25">
            WOMEN'S HEALTH | Advertorial
          </p>
        </div>
      </header>

      {/* Notification Banner */}
      <div className="w-full bg-amber-50 border border-amber-200" data-id="element-26">
        <div className="container mx-auto px-4 py-3 flex items-center justify-center text-center" data-id="element-27">
          <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={20} data-id="element-28" />
          <p className="font-bold text-sm sm:text-base" data-id="element-29">
            UPDATE: Elivara Compression Leggings Are Helping Women with Lipedema
            Have Safe Pregnancies! Get up to 40% OFF + Fast FREE Shipping Across
            the US
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4" data-id="element-30">
        <div className="flex flex-col lg:flex-row lg:justify-center" data-id="element-31">
          {/* Main Content */}
          <main className="w-full max-w-3xl mx-auto" data-id="element-32">
            <div className="py-6 px-0 md:px-4" data-id="element-33">
              {/* Headline */}
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4" data-id="element-34">
                {userCity} Lipedema Specialists Reveal: Why Women Are Delaying
                Pregnancy Because of Lipedema (And the Compression Breakthrough
                That's Giving Them Hope)
              </h1>

              {/* Subheadline */}
              <p className="text-lg md:text-xl text-gray-600 mb-6" data-id="element-35">
                Up to 17 million women in the US have lipedema — and many are
                terrified that pregnancy will make it worse. {userCity}{' '}
                specialists say there's finally a way to manage lipedema safely
                during your childbearing years.
              </p>

              {/* Author and Date */}
              <div className="flex items-center justify-between border-b border-gray-200 pb-4 mb-6" data-id="element-36">
                <div className="flex items-center" data-id="element-37">
                  <p className="text-sm text-gray-700" data-id="element-38">
                    By Jennifer Martinez, Women's Health | April 29, 2025
                  </p>
                </div>
                <div className="flex items-center text-sm text-gray-500" data-id="element-39">
                  <EyeIcon size={16} className="mr-1" data-id="element-40" />
                  <span data-id="element-41">312,847</span>
                </div>
              </div>

              {/* Featured Image */}
              <div className="mb-8 rounded-lg overflow-hidden" data-id="element-42">
                <img src="https://cdn.magicpatterns.com/uploads/7mqAXAiM1wFwX9H33z2bSs/ChatGPT_Image_1_Ιαν_2026,_03_56_23_μ.μ..png" alt="Woman looking at pregnancy test with worried expression, showing visible lipedema in her legs" className="w-full h-auto" data-id="element-43" />
              </div>

              {/* Personal Story Section */}
              <div className="mb-10" data-id="element-44">
                <p className="mb-4" data-id="element-45">
                  I'll never forget the conversation with my best friend when
                  she told me she was pregnant.
                </p>
                <p className="mb-4" data-id="element-46">I was happy for her. Of course I was.</p>
                <p className="mb-4" data-id="element-47">
                  But I also felt... jealous. And terrified.
                </p>
                <p className="mb-4" data-id="element-48">
                  Because I wanted a baby too. I'd wanted one for years.
                </p>
                <p className="mb-4" data-id="element-49">
                  But I had lipedema. And everything I'd read online said the
                  same thing:
                </p>
                <p className="mb-4" data-id="element-50">
                  "Pregnancy makes lipedema worse." "Hormones cause lipedema to
                  explode." "You'll progress from Stage 2 to Stage 3."
                </p>
                <p className="mb-4" data-id="element-51">
                  I was 34. My biological clock was ticking. And I felt trapped.
                </p>
                <p className="mb-4" data-id="element-52">
                  Have a baby and destroy my legs? Or protect my body and give
                  up on motherhood?
                </p>
                <p className="mb-4" data-id="element-53">
                  It wasn't a choice I should have had to make. But it felt like
                  the only choice I had.
                </p>
                <p className="mb-4" data-id="element-54">
                  I started avoiding baby showers. I stopped following friends
                  with kids on social media. Every pregnancy announcement felt
                  like a knife.
                </p>
                <p className="mb-4" data-id="element-55">
                  Not because I wasn't happy for them. But because it reminded
                  me of what I was giving up.
                </p>
                <p className="mb-4 font-semibold" data-id="element-56">Sound familiar?</p>
                <p className="mb-4" data-id="element-57">
                  If you're one of the thousands of women with lipedema who's
                  terrified to get pregnant — afraid the hormones will make your
                  condition explode, that you'll lose mobility, that you'll
                  regret it — I need you to keep reading.
                </p>
                <p className="mb-4" data-id="element-58">
                  Because what I discovered changed everything. And it might
                  change everything for you too.
                </p>
              </div>

              {/* The Fear Section */}
              <div className="mb-10" ref={firstTwoSectionsRef} data-id="element-59">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-60">
                  The Fear That Keeps Women from Starting Families
                </h2>
                {/* Medical Condition Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-61">
                  <img src="https://cdn.magicpatterns.com/uploads/3UU6ZyrFR4VoqRVRHZ9xGe/ChatGPT_Image_1_Ιαν_2026,_03_56_21_μ.μ..png" alt="Medical illustration showing lipedema fat tissue and fluid accumulation in pregnant woman's legs" className="w-full h-auto" data-id="element-62" />
                </div>
                <p className="mb-4" data-id="element-63">
                  Here's what {userCity} specialists want you to know:
                </p>
                <p className="mb-4" data-id="element-64">
                  Yes, pregnancy CAN affect lipedema. Hormones matter. Weight
                  gain matters. Fluid retention matters.
                </p>
                <p className="mb-4" data-id="element-65">
                  But here's what they don't tell you enough:
                </p>
                <p className="mb-4 font-semibold" data-id="element-66">
                  Pregnancy doesn't have to make lipedema worse.
                </p>
                <p className="mb-4" data-id="element-67">
                  "I see women in their 30s delay pregnancy for years out of
                  fear," says Dr. Rachel Chen. She's a lymphatic specialist at
                  the {userCity} Center for Lymphatic Health.
                </p>
                <p className="mb-4" data-id="element-68">
                  "They want children desperately. But they're terrified.
                  Terrified their legs will explode with fluid. Terrified
                  they'll progress to Stage 3 or Stage 4. Terrified they'll end
                  up unable to walk. Terrified they'll make a choice they can't
                  undo."
                </p>
                <p className="mb-4" data-id="element-69">
                  "And I tell them: With the right support, you don't have to
                  choose between having a baby and protecting your body."
                </p>
                <p className="mb-4" data-id="element-70">That word — support — is key.</p>
                <p className="mb-4" data-id="element-71">
                  Because most women with lipedema are trying to manage
                  pregnancy with the WRONG kind of compression. Or they're
                  avoiding compression entirely because traditional stockings
                  are unbearable.
                </p>
                <p className="mb-4" data-id="element-72">And that's where everything falls apart.</p>
                <p className="mb-4" data-id="element-73">
                  But first, you need to understand what lipedema actually is.
                  And why pregnancy scares you so much.
                </p>
              </div>

              {/* What Is Lipedema Section */}
              <div className="mb-10" data-id="element-74">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-75">
                  What Is Lipedema? (And Why Pregnancy Terrifies You)
                </h2>
                <p className="mb-4" data-id="element-76">
                  It turns out, I wasn't broken. I wasn't lazy. And I wasn't
                  eating "too much."
                </p>
                <p className="mb-4" data-id="element-77">
                  I had a legitimate medical condition called lipedema. And
                  according to the National Institutes of Health, it affects an
                  estimated 11% of women in the United States alone.
                </p>
                <p className="mb-4" data-id="element-78">That's roughly 17 million women.</p>
                <p className="mb-4" data-id="element-79">
                  Many of them are in their childbearing years. Many of them
                  want children. And many of them are terrified to get pregnant.
                </p>
                <p className="mb-4" data-id="element-80">Here's what lipedema actually is:</p>
                <p className="mb-4" data-id="element-81">
                  Lipedema is a disorder of fatty tissue. Fat accumulates
                  abnormally in your legs and sometimes arms. It creates a
                  disproportionate appearance.
                </p>
                <p className="mb-4" data-id="element-82">
                  The fat cells in lipedema are different from normal fat cells.
                  They're dysfunctional. They're inflamed. And they trap fluid
                  in the tissue.
                </p>
                <p className="mb-4" data-id="element-83">The telltale signs include:</p>
                <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-84">
                  <li data-id="element-85">
                    Disproportionately large legs compared to your upper body
                  </li>
                  <li data-id="element-86">Fat that doesn't respond to diet or exercise</li>
                  <li data-id="element-87">Legs that are painful, tender to touch, or feel heavy</li>
                  <li data-id="element-88">Easy bruising on the legs</li>
                  <li data-id="element-89">
                    Symmetrical fat distribution (both legs affected equally)
                  </li>
                  <li data-id="element-90">Swelling that worsens as the day goes on</li>
                </ul>
                <p className="mb-4" data-id="element-91">
                  You probably already know all of this. You've lived with it
                  for years.
                </p>
                <p className="mb-4" data-id="element-92">
                  But here's what terrifies you about pregnancy:
                </p>
                <p className="mb-4 font-semibold" data-id="element-93">
                  Pregnancy hormones can trigger lipedema or make it worse.
                </p>
                <p className="mb-4" data-id="element-94">
                  Estrogen and progesterone — the hormones that surge during
                  pregnancy — affect lipedema. Many women first develop lipedema
                  during puberty or pregnancy because of these hormonal changes.
                </p>
                <p className="mb-4 font-semibold" data-id="element-95">
                  Pregnancy weight gain can cause progression.
                </p>
                <p className="mb-4" data-id="element-96">
                  You're supposed to gain 25-35 pounds during pregnancy. That's
                  healthy. But for women with lipedema, that weight can
                  accumulate in the legs. It can push you from Stage 1 to Stage
                  2. Or Stage 2 to Stage 3.
                </p>
                <p className="mb-4 font-semibold" data-id="element-97">
                  Pregnancy fluid retention can cause massive swelling.
                </p>
                <p className="mb-4" data-id="element-98">
                  Your body retains 50% more fluid during pregnancy. For a woman
                  with lipedema — whose lymphatic system already struggles to
                  drain fluid — this can be devastating.
                </p>
                <p className="mb-4" data-id="element-99">You've read the horror stories.</p>
                <p className="mb-4" data-id="element-100">
                  Women who were Stage 1 before pregnancy and Stage 3 after.
                  Women who could walk normally before pregnancy and needed
                  canes after. Women who said "I wish I'd never gotten pregnant"
                  because of what it did to their legs.
                </p>
                <p className="mb-4" data-id="element-101">
                  So you've been waiting. Delaying. Hoping for a solution that
                  makes pregnancy safe.
                </p>
                <p className="mb-4" data-id="element-102">
                  And here's the truth: that solution exists.
                </p>
                <p className="mb-4" data-id="element-103">
                  But it's not what your doctor probably recommended.
                </p>
              </div>

              {/* Why Doctor's Advice Won't Work Section */}
              <div className="mb-10" data-id="element-104">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-105">
                  Why Your Doctor's Compression Advice Won't Work During
                  Pregnancy
                </h2>
                {/* Traditional Compression Stockings Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-106">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vZgTaXaxfHgpWtLhRDNWGn/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_30_%CF%80.%CE%BC..png" alt="Image showing traditional medical-grade compression stockings next to a frustrated woman trying to put them on, illustrating how uncomfortable and medical they look" className="w-full h-auto" data-id="element-107" />
                </div>
                <p className="mb-4" data-id="element-108">
                  Once I understood what lipedema was and how pregnancy could
                  affect it, the next question became obvious:
                </p>
                <p className="mb-4" data-id="element-109">What do I do if I want to get pregnant?</p>
                <p className="mb-4" data-id="element-110">
                  My doctor recommended compression stockings. You know, those
                  thick, medical-grade stockings. The ones that are impossible
                  to put on. The ones that cut into your skin. The ones that
                  look like something your grandmother would wear.
                </p>
                <p className="mb-4" data-id="element-111">I tried them. For about two weeks.</p>
                <p className="mb-4" data-id="element-112">
                  And honestly? They were unbearable. I couldn't imagine wearing
                  them throughout an entire pregnancy.
                </p>
                <p className="mb-4" data-id="element-113">
                  Here's why standard compression doesn't work for pregnant
                  women with lipedema:
                </p>
                <div className="bg-red-50 p-4 rounded-md mb-6" data-id="element-114">
                  <p className="font-semibold mb-2" data-id="element-115">
                    Problem #1: They Apply the Same Pressure Everywhere
                  </p>
                  <p className="mb-3" data-id="element-116">
                    Traditional compression stockings use uniform pressure from
                    top to bottom. They squeeze your entire leg with the same
                    intensity. But your legs aren't uniform. And your lymphatic
                    system doesn't work uniformly either. It needs directional
                    support to move fluid upward and out. Without that gradient,
                    fluid just gets squeezed with nowhere to go.
                  </p>
                  <p className="font-semibold mb-2" data-id="element-117">
                    Problem #2: They Create a Tourniquet Effect
                  </p>
                  <p className="mb-3" data-id="element-118">
                    When compression is too tight or applied incorrectly, it
                    creates a tourniquet effect. It traps fluid rather than
                    moving it. And during pregnancy? When you're already
                    retaining massive amounts of extra fluid? This makes
                    everything unbearable.
                  </p>
                  <p className="font-semibold mb-2" data-id="element-119">
                    Problem #3: They're Uncomfortable and Obvious
                  </p>
                  <p className="mb-3" data-id="element-120">
                    Pregnancy is hard enough. You're nauseous. You're exhausted.
                    The last thing you need is compression stockings that take
                    15 minutes to put on, make you sweat, dig into your skin,
                    and look obviously medical. You can't wear them under normal
                    maternity clothes.
                  </p>
                  <p className="font-semibold mb-2" data-id="element-121">
                    Problem #4: They Don't Address the Root Cause
                  </p>
                  <p className="mb-3" data-id="element-122">
                    Lipedema happens because your lymphatic system isn't
                    draining fluid properly. Standard compression just squeezes
                    everything equally without specifically targeting lymphatic
                    flow. During pregnancy — when your lymphatic system is
                    already overloaded — this becomes critical.
                  </p>
                </div>
                <p className="mb-4" data-id="element-123">
                  I felt stuck. The only "solution" available was something I
                  couldn't stand to wear. Something that didn't even work that
                  well. Something that would make me feel even more
                  self-conscious during pregnancy.
                </p>
                <p className="mb-4" data-id="element-124">
                  That's when I realized: the problem wasn't compression itself
                  — it was the wrong kind of compression.
                </p>
                <p className="mb-4" data-id="element-125">
                  There had to be something better. Something designed for women
                  like me who wanted to be mothers AND manage lipedema.
                </p>
                <p className="mb-4" data-id="element-126">And that's when everything changed.</p>
              </div>

              {/* The Breakthrough Section */}
              <div className="mb-10" data-id="element-127">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-128">
                  The Compression Breakthrough That Changes Everything for
                  Pregnancy
                </h2>
                {/* Elivara Leggings Product Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-129">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qXr4YxNDa3ZLDxwoFvkcy4/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_34_%CF%80.%CE%BC..png" alt="Image of Elivara compression leggings showing the stylish design with FlowMapping™ technology zones highlighted with glowing orange lines" className="w-full h-auto" data-id="element-130" />
                </div>
                <p className="mb-4" data-id="element-131">
                  That's when I discovered Elivara — and specifically, their
                  revolutionary FlowMapping™ Compression technology.
                </p>
                <p className="mb-4" data-id="element-132">
                  When I first heard about it, I was skeptical. Another
                  compression product? Really?
                </p>
                <p className="mb-4" data-id="element-133">
                  But Elivara is fundamentally different from anything else on
                  the market. And the difference comes down to one key insight:
                  Your body has natural pathways for lymphatic drainage.
                  Compression needs to follow those pathways — not fight against
                  them.
                </p>
                <p className="mb-4" data-id="element-134">
                  Especially during pregnancy, when your lymphatic system is
                  already working overtime.
                </p>
                <p className="mb-4" data-id="element-135">Here's how FlowMapping™ actually works:</p>
                <p className="mb-4" data-id="element-136">
                  Instead of applying uniform pressure across your entire leg
                  like old-school compression stockings, Elivara uses graduated
                  pressure zones.
                </p>
                <p className="mb-4" data-id="element-137">
                  These zones are specifically designed to match your body's
                  lymphatic system.
                </p>
                <p className="mb-4" data-id="element-138">
                  Think of it like this: Your lymphatic fluid needs to move in a
                  specific direction. Up and out of your legs. Back toward your
                  core.
                </p>
                <p className="mb-4" data-id="element-139">
                  FlowMapping™ creates a gentle pressure gradient that guides
                  trapped fluid along your natural drainage pathways. It
                  accelerates lymphatic flow without creating that uncomfortable
                  tourniquet effect.
                </p>
                <p className="mb-4" data-id="element-140">
                  The pressure is strongest at your ankles — about 25
                  millimeters of mercury. That's where fluid tends to pool the
                  most. Then it gradually decreases as it moves up your leg.
                  This gradient naturally encourages fluid to move upward and
                  drain properly.
                </p>
                <p className="mb-4" data-id="element-141">
                  But here's what really sets Elivara apart: They designed these
                  specifically for women with lipedema. Not for varicose veins.
                  Not for elderly patients with general swelling. For women with
                  lipedema who want to live normal lives. Including women who
                  want to have babies.
                </p>
                <p className="mb-4" data-id="element-142">
                  And they designed compression that works WITH your body's
                  changes during pregnancy.
                </p>
                <p className="mb-4" data-id="element-143">
                  As your body retains more fluid during pregnancy,
                  FlowMapping™ helps drain it properly. Every single day.
                </p>
                <p className="mb-4" data-id="element-144">
                  As your hormones fluctuate, the graduated pressure keeps
                  supporting your lymphatic system.
                </p>
                <p className="mb-4" data-id="element-145">
                  As your weight changes, the leggings adapt. They stretch
                  comfortably over your growing belly. They don't create painful
                  pressure points. They don't cut off circulation.
                </p>
                <p className="mb-4" data-id="element-146">
                  The result? Leggings that deliver therapeutic-level relief
                  while looking and feeling like regular maternity activewear.
                </p>
                <p className="mb-4" data-id="element-147">
                  Many women wear Elivara throughout their entire pregnancy. And
                  postpartum too.
                </p>
                <p className="mb-4 font-semibold" data-id="element-148">
                  I'm not exaggerating when I say these changed my decision
                  about motherhood.
                </p>
              </div>

              {/* Visual Explanation Section */}
              <div className="mb-10" data-id="element-149">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-150">
                  See the FlowMapping™ Difference
                </h2>
                <div className="mb-6 rounded-lg overflow-hidden bg-blue-50 p-4" data-id="element-151">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4ge5gzuHf48wNS9HaJaGCz/gempages_541671622348637232-7a3a123c-f1c8-4b25-b1a4-f051e570e74b.webp" alt="Animation showing the difference between painful lipedema fluid buildup (left, red areas) and the FlowMapping™ technology directing fluid flow (right, green chevrons)" className="w-full h-auto mx-auto" data-id="element-152" />
                  <div className="flex justify-between mt-4 text-sm md:text-base" data-id="element-153">
                    <div className="text-center w-1/2 border-r border-blue-200 pr-2" data-id="element-154">
                      <p className="font-bold text-red-500 mb-1" data-id="element-155">
                        WITHOUT SUPPORT
                      </p>
                      <p className="text-gray-700" data-id="element-156">
                        Painful fluid buildup and inflammation
                      </p>
                    </div>
                    <div className="text-center w-1/2 pl-2" data-id="element-157">
                      <p className="font-bold text-green-500 mb-1" data-id="element-158">
                        WITH FLOWMAPPING™
                      </p>
                      <p className="text-gray-700" data-id="element-159">
                        Guided fluid drainage along natural pathways
                      </p>
                    </div>
                  </div>
                </div>
                <p className="mb-4" data-id="element-160">
                  This visual perfectly captures what makes FlowMapping™
                  technology so revolutionary.
                </p>
                <p className="mb-4" data-id="element-161">
                  On the left, you can see what happens in lipedema-affected
                  legs during pregnancy. Fluid builds up (shown in red). It
                  creates painful inflammation and swelling that gets worse as
                  pregnancy progresses.
                </p>
                <p className="mb-4" data-id="element-162">
                  On the right, you see how Elivara's patented FlowMapping™
                  technology works. The strategically placed compression zones
                  (shown as green chevrons) create directional pressure. They
                  guide trapped fluid along your natural lymphatic pathways.
                </p>
                <p className="mb-4" data-id="element-163">
                  This helps your body drain the fluid properly. It reduces
                  swelling. It reduces pain. It reduces that heavy feeling that
                  comes with lipedema — especially during pregnancy when
                  everything feels heavier.
                </p>
                <p className="mb-4" data-id="element-164">
                  This is why women report feeling immediate relief when they
                  put them on. The technology is actively working with your
                  body's natural systems, not against them.
                </p>
              </div>

              {/* What It Feels Like Section */}
              <div className="mb-10" data-id="element-165">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-166">
                  What It Actually Feels Like to Wear Them During Pregnancy
                </h2>
                {/* Woman Wearing Elivara Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-167">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oMv6AwMrRLHqTtLr2LbQQk/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_36_%CF%80.%CE%BC..png" alt="Image of a smiling woman wearing Elivara leggings while doing everyday activities, showing how they look like normal leggings but provide therapeutic benefits" className="w-full h-auto" data-id="element-168" />
                </div>
                <p className="mb-4" data-id="element-169">
                  The first time I put on my Elivara leggings, I noticed the
                  difference immediately.
                </p>
                <p className="mb-4" data-id="element-170">
                  They weren't difficult to get on like traditional compression
                  stockings. They felt like... leggings. Comfortable, soft,
                  breathable maternity leggings that I'd actually want to wear.
                </p>
                <p className="mb-4" data-id="element-171">
                  But within an hour, I felt something I hadn't felt in years:
                  my legs felt lighter.
                </p>
                <p className="mb-4" data-id="element-172">
                  That heavy, swollen feeling I'd gotten so used to? It started
                  to ease.
                </p>
                <p className="mb-4" data-id="element-173">
                  I wore them every day during my entire pregnancy. And the
                  changes kept coming:
                </p>
                <div className="space-y-4 mb-6" data-id="element-174">
                  <div className="flex items-start" data-id="element-175">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-176" />
                    <p data-id="element-177">
                      <span className="font-semibold" data-id="element-178">
                        My legs looked slimmer despite pregnancy weight gain.
                      </span>{' '}
                      The constant swelling that made my legs appear even larger
                      started to reduce. Yes, I gained weight during pregnancy.
                      That's normal and healthy. But the fluid swelling — the
                      lipedema swelling — was controlled.
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-179">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-180" />
                    <p data-id="element-181">
                      <span className="font-semibold" data-id="element-182">
                        The pain decreased significantly.
                      </span>{' '}
                      Lipedema legs are often tender and painful to touch.
                      Pregnancy makes this worse for most women. The
                      FlowMapping™ compression reduced inflammation and fluid
                      buildup. That meant less pain. Less tenderness.
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-183">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-184" />
                    <p data-id="element-185">
                      <span className="font-semibold" data-id="element-186">I had more energy.</span>{' '}
                      When you're pregnant AND carrying around excess fluid in
                      your legs all day, it's exhausting. Once that fluid
                      started draining properly, I genuinely had more energy to
                      get through my day.
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-187">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-188" />
                    <p data-id="element-189">
                      <span className="font-semibold" data-id="element-190">I didn't progress.</span>{' '}
                      This was the big one. The fear that kept me from getting
                      pregnant for years. I was Stage 2 when I got pregnant.
                      After I gave birth? I was still Stage 2. My lipedema
                      didn't "explode" like I'd feared.
                    </p>
                  </div>
                </div>
                <p className="mb-4" data-id="element-191">
                  Elivara gave me something I thought I'd lost forever: the
                  freedom to become a mother without sacrificing my body.
                </p>
              </div>

              {/* Testimonials Section */}
              <div className="mb-10" data-id="element-192">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-6" data-id="element-193">
                  Real Women Who Got Pregnant with Lipedema — And Managed It
                  Successfully
                </h2>
                {/* Before/After Results Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-194">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8J75MXwWaCcwc1FvqhjnYB/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_42_%CF%80.%CE%BC..png" alt="Before and after comparison showing 'Without Support' vs 'With Elivara' illustrating the visible reduction in swelling and improved leg shape" className="w-full h-auto" data-id="element-195" />
                </div>
                <p className="mb-6" data-id="element-196">
                  I'm not the only one who's experienced this. Thousands of
                  women with lipedema have used Elivara during pregnancy. Here's
                  what they say:
                </p>
                <div className="space-y-6 mb-6" data-id="element-197">
                  <TestimonialCard quote="I delayed getting pregnant for 3 years because I was terrified. I had Stage 2 lipedema and read horror stories about women progressing during pregnancy. But I wanted a baby so badly. I wore Elivara every single day of my pregnancy. My legs stayed stable. The swelling was manageable. I didn't progress. I have a healthy baby girl now and I can still walk, chase her around, live my life." author="Sarah M." age="36" location="Chicago, IL" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/3y7To7DiABw2UivqWYkvYv/images_%2842%29.jpg" data-id="element-198" />
                  <TestimonialCard quote="My doctor told me pregnancy would make my lipedema worse. She made it sound inevitable. I almost didn't get pregnant because of that conversation. But then I found Elivara and a community of women with lipedema who'd had successful pregnancies. I wore them every day. The swelling was controlled. Now I'm 6 months postpartum and my legs are the same as before pregnancy. Not worse. And I'm planning for baby #2." author="Amanda K." age="33" location="Austin, TX" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/jA5TbK1HAopveddK7FXfLL/mockup-pretty-curvy-latin-woman-600nw-2460705183.webp" data-id="element-199" />
                  <TestimonialCard quote="I wish I'd found these sooner. During my first pregnancy, I wore traditional compression stockings. They were unbearable. I stopped wearing them by my second trimester. My legs swelled terribly and I was in constant pain. When I got pregnant with my second baby, I found Elivara. Night and day difference. My legs felt lighter. The pain was manageable. I could actually enjoy being pregnant this time." author="Jennifer R." age="38" location="Miami, FL" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/1ZzQbxP1337U3TnJrDfMSW/istockphoto-1290775513-612x612.jpg" data-id="element-200" />
                  <TestimonialCard quote="I thought I'd missed my chance. I'm 45 with Stage 2 lipedema. I'd spent my 30s too scared to get pregnant. But at 43, I decided: I'm doing this. I found Elivara before I got pregnant and wore them every single day. I gave birth to a healthy boy at 44. He's 18 months old now. And my legs? Still Stage 2. Not worse. I didn't think I could have both. A child and manageable lipedema. But I do." author="Michelle T." age="45" location="Denver, CO" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/8hW674k71ojpsCMkVCgv6R/Screenshot_2025-09-30_at_00.02.40.png" data-id="element-201" />
                  <TestimonialCard quote="During my first pregnancy I wore traditional compression that cut into my legs and left marks. They were so uncomfortable I could barely make it through the day. Elivara is completely different. They're soft, they breathe, and they actually reduce my swelling without that horrible tourniquet feeling. I wear them literally every single day now and I'm planning my second pregnancy with confidence." author="Melissa J." age="34" location="Portland, OR" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/hq1HCFwLGMXQeBfL6EFNpY/istockphoto-1180524344-612x612.jpg" data-id="element-202" />
                  <TestimonialCard quote="For years I thought I was destined to choose between having kids and protecting my legs. Finding out I had lipedema was validating, but I still didn't know what to do about pregnancy. Elivara changed that. The FlowMapping™ technology actually works. My legs feel lighter, they look better, and most importantly — I'm not in constant pain during my pregnancy. I'm 7 months along and feeling hopeful." author="Rebecca L." age="31" location="Nashville, TN" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/vLXJxevCdw389ZygZwFFUQ/Screenshot_2025-09-30_at_00.02.43.png" data-id="element-203" />
                  <TestimonialCard quote="Before Elivara, I was terrified that pregnancy would make my lipedema explode. I'd read about women progressing from Stage 1 to Stage 3 during pregnancy. But I wore Elivara throughout my entire pregnancy and postpartum period. My legs stayed stable. I didn't progress. Now I have a beautiful 6-month-old and I'm so grateful I didn't let fear stop me from becoming a mother." author="Linda M." age="37" location="Seattle, WA" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/nJ43KvrRnAa3kWNkkTfCWz/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_12_12_37_%CF%80.%CE%BC..png" data-id="element-204" />
                  <TestimonialCard quote="I spent years avoiding baby showers and pregnancy announcements because they reminded me of what I was giving up. I wanted children but I was terrified of what pregnancy would do to my lipedema. Elivara gave me hope. I wore them throughout my pregnancy and the fluid retention was manageable. I didn't progress. I have a healthy baby and my body is okay. That's all I wanted." author="Patricia D." age="35" location="Boston, MA" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/eb9DbMXxnEv4xRdj6M31AN/Beth_-_living_with_lipedema.webp" data-id="element-205" />
                </div>
              </div>

              {/* Why Elivara Works Section */}
              <div className="mb-10" data-id="element-206">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-207">
                  Why Elivara Works When Everything Else Failed
                </h2>
                <p className="mb-4" data-id="element-208">
                  You might be wondering: What makes Elivara so different from
                  all the other compression products out there?
                </p>
                <p className="mb-4" data-id="element-209">It comes down to three key factors:</p>
                {/* FlowMapping Technology Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-210">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sngffNnPS6asvvdqPakuVW/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_52_%CF%80.%CE%BC..png" alt="Illustration comparing Traditional Compression with uniform pressure versus FlowMapping™ Technology with directional support following the lymphatic system pathways" className="w-full h-auto" data-id="element-211" />
                </div>
                <div className="space-y-6 mb-6" data-id="element-212">
                  <div className="bg-blue-50 p-6 rounded-lg" data-id="element-213">
                    <h3 className="font-bold text-lg mb-2" data-id="element-214">
                      1. Lipedema-Specific Design
                    </h3>
                    <p data-id="element-215">
                      Elivara isn't generic compression. Every design element is
                      based on research into lipedema. Including women who want
                      to get pregnant. The design accounts for the changes your
                      body goes through during pregnancy. The extra fluid
                      retention. The hormonal fluctuations. The weight gain.
                      It's compression that works WITH those changes, not
                      against them.
                    </p>
                  </div>
                  <div className="bg-blue-50 p-6 rounded-lg" data-id="element-216">
                    <h3 className="font-bold text-lg mb-2" data-id="element-217">
                      2. FlowMapping™ Technology
                    </h3>
                    <p data-id="element-218">
                      The graduated pressure system creates a precise pressure
                      gradient that follows your body's natural lymphatic
                      pathways. It gently guides trapped fluid where it needs to
                      go. And during pregnancy — when your body is retaining 50%
                      more fluid than normal — having that drainage pathway
                      makes all the difference.
                    </p>
                  </div>
                  <div className="bg-blue-50 p-6 rounded-lg" data-id="element-219">
                    <h3 className="font-bold text-lg mb-2" data-id="element-220">
                      3. Comfortable Enough to Wear Throughout Pregnancy
                    </h3>
                    <p data-id="element-221">
                      Elivara understands that a solution only works if you
                      actually use it. These leggings look stylish. Feel
                      comfortable. And work with your life. You can wear them
                      throughout pregnancy. To work. To prenatal appointments.
                      Running errands. They don't look medical. They just look
                      like maternity leggings that happen to provide
                      therapeutic-level relief.
                    </p>
                  </div>
                </div>
              </div>

              {/* First CTA Section */}
              <div className="mb-10 bg-gray-100 p-6 rounded-lg" data-id="element-222">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-223">
                  This Is Your Chance to Have the Family You Want
                </h2>
                {/* Product Packaging Image */}
                <div className="mb-6 bg-white rounded-lg overflow-hidden" data-id="element-224">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/23Hx8bzAVQ7dcDK8zTNUdC/Trusted_by_Women_Across_the_USA.png" alt="Elivara Lipedema Leggings with premium packaging, 30-day money back guarantee, and free shipping" className="w-full h-auto" data-id="element-225" />
                </div>
                <p className="mb-4" data-id="element-226">
                  Here's something important: Because Elivara uses specialized
                  FlowMapping™ technology and lipedema-specific design, they
                  can only produce limited quantities of these leggings.
                </p>
                <p className="mb-4" data-id="element-227">
                  And right now, they're offering first-time customers an
                  exclusive opportunity to save 40% off their order.
                </p>
                <p className="mb-4" data-id="element-228">
                  This isn't a permanent discount. It's specifically designed to
                  help women who've been delaying pregnancy because of lipedema.
                  To help them finally access a solution that actually works —
                  without the premium price tag that usually comes with
                  specialized medical garments.
                </p>
                <p className="mb-4" data-id="element-229">
                  But here's the reality: these sell out. Fast.
                </p>
                <p className="mb-4" data-id="element-230">
                  When women with lipedema discover compression that's
                  comfortable enough to wear daily AND effective enough to
                  manage symptoms during pregnancy, word spreads. Popular sizes
                  often disappear within days.
                </p>
                <p className="mb-4 font-semibold" data-id="element-231">
                  I don't want you to miss this opportunity.
                </p>
                <p className="mb-4" data-id="element-232">
                  If you've been putting off pregnancy because you're terrified
                  of what lipedema will do to your body...
                </p>
                <p className="mb-4" data-id="element-233">
                  If you're tired of choosing between having a baby and
                  protecting your legs...
                </p>
                <p className="mb-4" data-id="element-234">
                  If you want to start a family but you need support that
                  actually works...
                </p>
                <p className="mb-4" data-id="element-235">This is your chance.</p>
              </div>

              {/* Final Section */}
              <div className="mb-10" data-id="element-236">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-237">
                  You Don't Have to Choose Between Motherhood and Your Body
                </h2>
                {/* Lifestyle Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-238">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fcFTP9s5La88PDr9GNhj1H/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_56_%CF%80.%CE%BC..png" alt="Woman confidently walking on the beach wearing a dress with compression leggings, enjoying freedom and comfort after using Elivara to manage her lipedema" className="w-full h-auto" data-id="element-239" />
                </div>
                <p className="mb-4" data-id="element-240">
                  I want you to imagine something for a moment.
                </p>
                <p className="mb-4" data-id="element-241">
                  Imagine finding out you're pregnant and feeling excited
                  instead of terrified.
                </p>
                <p className="mb-4" data-id="element-242">
                  Imagine going through pregnancy with compression that's
                  comfortable. That works. That helps your legs feel lighter
                  instead of heavier.
                </p>
                <p className="mb-4" data-id="element-243">
                  Imagine not progressing. Not losing mobility. Not ending up
                  worse than you started.
                </p>
                <p className="mb-4" data-id="element-244">
                  Imagine holding your baby and thinking: "I did this. I became
                  a mother. And my body is okay."
                </p>
                <p className="mb-4" data-id="element-245">
                  Imagine just... living. Being a mom. Without lipedema stealing
                  that from you.
                </p>
                <p className="mb-4" data-id="element-246">
                  That's what Elivara gave me. And that's what it can give you.
                </p>
                <p className="mb-4" data-id="element-247">
                  You're not alone. You're not broken. And you're not imagining
                  this condition.
                </p>
                <p className="mb-4" data-id="element-248">
                  Lipedema is real. It's valid. And it doesn't have to steal
                  motherhood from you.
                </p>
                <p className="mb-4" data-id="element-249">
                  You can have both. A baby and manageable lipedema.
                </p>
                <p className="mb-4" data-id="element-250">
                  But you need the right support. And you need to act before
                  your biological clock runs out.
                </p>
                <p className="mb-6 font-semibold" data-id="element-251">
                  Don't let another year go by. Don't let another friend's
                  pregnancy announcement break your heart. Don't let lipedema
                  steal the family you deserve.
                </p>
              </div>
            </div>
          </main>

          {/* Right-side CTA - Always visible on desktop */}
          <aside className="hidden lg:block lg:w-80 lg:ml-8 lg:flex-shrink-0 mt-6" data-id="element-252">
            <div className="sticky top-6" data-id="element-253">
              <StickyCTA showNewImage={true} data-id="element-254" />
            </div>
          </aside>
        </div>
      </div>

      {/* Sticky CTA - Always visible at the bottom */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 z-50" data-id="element-255">
        <a href="https://tryelivara.com/pages/elivara-landing-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg shadow-md transition-all w-full uppercase tracking-wider text-center block" data-id="element-256">
          GET 40% OFF ELIVARA LEGGINGS NOW!
        </a>
      </div>

      {/* Special Offer Banner */}
      <div className="w-full bg-red-50 border-y border-red-200" data-id="element-257">
        <div className="container mx-auto px-4 py-6" data-id="element-258">
          <div className="flex flex-col sm:flex-row items-center justify-center text-center gap-4" data-id="element-259">
            <div className="flex items-center" data-id="element-260">
              <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={24} data-id="element-261" />
              <p className="font-bold text-lg" data-id="element-262">SPECIAL OFFER:</p>
            </div>
            <p className="font-bold text-red-700 text-lg px-4" data-id="element-263">
              Get Elivara Compression Leggings at 40% OFF + FREE Shipping - Safe
              for Pregnancy!
            </p>
            <a href="https://tryelivara.com/pages/elivara-landing-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg text-base whitespace-nowrap inline-block" data-id="element-264">
              CLAIM OFFER
            </a>
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <footer className="w-full bg-gray-100" data-id="element-265">
        <div className="container mx-auto px-4 py-6 max-w-4xl" data-id="element-266">
          <div className="text-xs text-gray-500 pt-6 mb-8" data-id="element-267">
            <p className="mb-2" data-id="element-268">
              This is an advertisement and not an actual news article, blog, or
              consumer protection update. Individual results may vary. The
              testimonials presented are from actual customers but may not
              represent typical results.
            </p>
            <div className="flex flex-wrap space-x-2 mb-2" data-id="element-269">
              <span data-id="element-270">About Us</span>
              <span data-id="element-271">|</span>
              <span data-id="element-272">Terms of Use</span>
              <span data-id="element-273">|</span>
              <span data-id="element-274">Privacy Policy</span>
            </div>
            <p className="mb-2" data-id="element-275">
              Trademarks utilized on our website belong to their respective
              owners and no implied or expressed endorsement of our website or
              services is intended. Through in-depth research and experienced
              editors we provide feedback about products and services. We are
              independently owned, and opinions expressed here are our own. This
              website is an independent professional comparison and review site
              supported by referral fees from the sites and products featured.
            </p>
            <p data-id="element-276">©2025 Women's Health Insights. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    </div>;
};